import { Route, Routes } from 'react-router';

import AssistantTab from './AssistantTab';

export default function AssistantRoutes() {
  return (
    <Routes>
      <Route index element={<AssistantTab />} />
    </Routes>
  );
}
